import React, { FunctionComponent, PropsWithChildren } from 'react';

import {
  default as MuiDialogContent,
  DialogContentProps,
} from '@mui/material/DialogContent';

const DialogContent: FunctionComponent<DialogContentProps> = (
  props: PropsWithChildren<DialogContentProps>
) => {
  return <MuiDialogContent {...props}>{props.children}</MuiDialogContent>;
};

export default DialogContent;
